import React, { useMemo } from 'react';
import {
	Container,
	ModalContainer,
	PageBreadcrumbs,
	PageTitle,
	SEOProductSchema,
	StoreBlock,
	StoreSelectionModal,
} from 'common/components';
import { useInstore } from '../hooks';
import { useInstoreService } from './hooks';
import {
	AnalizVodyManual,
	// AnalizVodyPromotion,
	AnalizVodySteps,
	Benefits,
	Caption,
	DefaultSchedule,
	OtherCategories,
	Reasons,
	RezkaDereva,
	Services,
	SmallText,
	Steps,
} from './components';
import { PageTitleMargin, StepsMargin, Wrapper } from './styles';

export const InstoreService = () => {
	const {
		isModalOpen,
		openModal,
		closeModal,
		selectedStoreCode,
		selectedStoreData,
		stores,
	} = useInstore();

	const { categoryId, services, pageTexts, isSmallScreen } = useInstoreService();

	const { smallText, reasons, servicesTitle, steps, benefits, caption, schedule } = pageTexts;

	const storeData = {
		...selectedStoreData,
		schedule: schedule.selected,
	};

	const isRezkaDereva = useMemo(() => categoryId === '2137', [categoryId]);
	const isAnalizVody = useMemo(() => categoryId === '2133', [categoryId]);
	const stepsStyles = benefits ? '' : StepsMargin;
	const stepsCmp = useMemo(
		() =>
			isAnalizVody ? (
				<AnalizVodySteps {...steps} className={stepsStyles} />
			) : (
				<Steps {...steps} className={stepsStyles} />
			),
		[isAnalizVody, steps, stepsStyles]
	);

	const isDefaultScheduleVisible = !selectedStoreCode || (!services.length && selectedStoreCode);

	const scheduleText =
		!services.length && selectedStoreCode
			? 'Для уточнения наличия услуги в городе выберите другой магазин'
			: schedule.default;
	// const isPromotionVisible = isAnalizVody && !selectedStoreCode;

	return (
		<section data-qa="instore-service-page">
			<Container>
				<PageBreadcrumbs />
				<Wrapper data-qa="wrapper">
					<div>
						<PageTitle className={PageTitleMargin} />
						<SmallText texts={smallText} />
						<Reasons {...reasons} />
						{/* оставил на следующий год, достаточно раскомитить */}
						{/* {isPromotionVisible && <AnalizVodyPromotion />} */}
						<StoreBlock
							selectedStoreCode={selectedStoreCode}
							selectedStoreData={storeData}
							storesCount={stores.length}
							onClick={openModal}
						/>
						<Services
							serviceGroups={services}
							servicesTitle={servicesTitle}
							selectedStoreCode={selectedStoreCode}
						/>
						{isRezkaDereva && services.length > 0 && <RezkaDereva />}
						<Benefits benefits={benefits} />
						{isSmallScreen && stepsCmp}
						{isAnalizVody && <AnalizVodyManual />}
						<Caption text={caption} />
						{isDefaultScheduleVisible && <DefaultSchedule text={scheduleText} />}
					</div>
					{!isSmallScreen && <>{stepsCmp}</>}
				</Wrapper>
			</Container>
			<OtherCategories />
			<ModalContainer isOpen={isModalOpen} onClose={closeModal} variant="curtain">
				<StoreSelectionModal selectedStoreCode={selectedStoreCode} storesList={stores} />
			</ModalContainer>
			<SEOProductSchema />
		</section>
	);
};
